import CodeEditor from "components/CodeEditor";
import { External } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";

import { showNewModuleAttachedPolicyPreviewDrawer } from "./PreviewDrawer";
import styles from "./styles.module.css";

type NewModuleAttachedPolicyContentProps = {
  policyBody: string;
};

const NewModuleAttachedPolicyContent = ({ policyBody }: NewModuleAttachedPolicyContentProps) => {
  const handleOpenDrawer = () => {
    showNewModuleAttachedPolicyPreviewDrawer({
      policyBody,
    });
  };

  return (
    <Box className={styles.codeEditorWrapper}>
      <ButtonIcon
        className={styles.codeEditorExpandButton}
        icon={External}
        onPress={handleOpenDrawer}
        variant="secondary"
      >
        Preview
      </ButtonIcon>
      <CodeEditor body={policyBody} language="rego" readOnly />
    </Box>
  );
};

export default NewModuleAttachedPolicyContent;
